import { createContext } from 'react';

export const statusContext = createContext(Object.freeze({
  unchecked: 0,
  checked: 1,
  indeterminate: -1
}))

export const seedContent = createContext({
  categories: {
    heading: 'Categories',
  },
  venues: {
    heading: 'Filter by venue',
  }
})

// for selection of initially available categories without adding a flag into the back-end, the client was happy to use hard-coded taxonomy id attributes.
// these are they.
export const initialItems = createContext({
  categories: ['526', '561'],
  venues: []
})

export const seedFilters = createContext({
  categories: [{
    status: -1,
    processed: false,
    id: "select_all_categories",
    name: "Select all",
    top: true,
    items: [
        {
          status: 0,
          id: "road_closures",
          name: "Road closures",
          parent: null,
          icon: "/modules/custom/map_react/sopa--map/src/assets/warning.svg",
        }
      ],
  }],
  venues: [{
    status: 1,
    processed: false,
    id: "select_all_venues",
    name: "Select all",
    top: true,
    items: []
  }]
})
